module.exports = __webpack_public_path__ + "media/bootstrap-icons/patch-question-c6299318.svg";